import React, { useState, useLayoutEffect, useCallback } from "react";
import { initialize, register } from "@sbd-ctg/user-behavior-tracking";

import Products from "./components/products/Products";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./components/login/Login";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import ResetPassword from "./components/resetPassword/ResetPassword";
import SsoCallback from "./components/sso/SsoCallback";
import { parseAuthQueryParams } from "./components/common/utils";

function App() {
  const [token, setToken] = useState(localStorage["msuite_token"]);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [forgotPasswordUsername, setForgotPasswordUsername] = useState("");
  const [queryAuth, setQueryAuth] = useState({});
  const [ssoUrlError, setSsoUrlError] = useState("");
  const [passwordResetRequiredNotice, setPasswordResetRequiredNotice] =
    useState(false);

  const userBehaviorToken = `${process.env.REACT_APP_USER_BEHAVIOR_TRACKING_TOKEN}`;
  initialize(userBehaviorToken);
  register({
    product: "msuite fab",
    version: "2.5",
    application: "web",
  });

  const handleSsoCallbackError = useCallback((message) => {
    setSsoUrlError(message);
    setQueryAuth((prev) => {
      const next = { ...prev };
      delete next.token;
      delete next.error;
      return next;
    });
  }, []);

  const handleCloseForgotPassword = useCallback(() => {
    setIsForgotPassword(false);
    setPasswordResetRequiredNotice(false);
    setForgotPasswordUsername("");
  }, []);

  const handlePasswordResetRequired = useCallback((username = "") => {
    setPasswordResetRequiredNotice(true);
    setForgotPasswordUsername(
      typeof username === "string" ? username.trim() : ""
    );
    setIsForgotPassword(true);
  }, []);

  useLayoutEffect(() => {
    const parsed = parseAuthQueryParams(
      window.location?.search,
      window.location?.hash
    );
    setQueryAuth(parsed);

    if (
      parsed.passwordResetRequired === "true" ||
      parsed.passwordResetRequired === "1"
    ) {
      setPasswordResetRequiredNotice(true);
      setIsForgotPassword(true);
      const fromUrl = (parsed.User || parsed.username || "").trim();
      if (fromUrl) {
        setForgotPasswordUsername(fromUrl);
      }
    }
    if (parsed.forgotPassword === "true" || parsed.forgotPassword === "1") {
      setIsForgotPassword(true);
      const fromUrl = (parsed.User || parsed.username || "").trim();
      if (fromUrl) {
        setForgotPasswordUsername(fromUrl);
      }
    }

    if (
      parsed.token ||
      parsed.error ||
      parsed.passwordResetRequired ||
      parsed.forgotPassword
    ) {
      const cleanUrl = window.location.pathname || "/";
      window.history.replaceState(null, "", cleanUrl);
    }
  }, []);

  const hasSsoCallback = Boolean(queryAuth?.token || queryAuth?.error);

  const renderLogin = () => {
    if (hasSsoCallback) {
      return (
        <SsoCallback queryAuth={queryAuth} onError={handleSsoCallbackError} />
      );
    }

    return (
      <Login
        urlError={ssoUrlError}
        onClearUrlError={() => setSsoUrlError("")}
        setIsForgotPassword={setIsForgotPassword}
        onPasswordResetRequired={handlePasswordResetRequired}
      />
    );
  };

  return (
    <>
      <CssBaseline />
      {isForgotPassword ? (
        <ForgotPassword
          setIsForgotPassword={handleCloseForgotPassword}
          initialUsername={forgotPasswordUsername}
          passwordResetRequiredNotice={passwordResetRequiredNotice}
        />
      ) : (
        <div className="App">
          {token ? (
            <Products setToken={setToken} token={token} />
          ) : queryAuth?.Auth_Key && queryAuth?.Auth_Key !== "" ? (
            <ResetPassword queryAuth={queryAuth} setQueryAuth={setQueryAuth} />
          ) : (
            renderLogin()
          )}
        </div>
      )}
    </>
  );
}

export default App;
